import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6e09994a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "bg-light mb-2 mt-3 py-1 px-2 shadow-sm rounded" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "d-flex justify-content-center" }, [
    /*#__PURE__*/ _createElementVNode("h5", { class: "mt-n3 mb-1 text-dark" }, "Último passo")
], -1));
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-12" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, " Descrição ", -1));
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("legend", null, [
    /*#__PURE__*/ _createTextVNode("Redes Sociais "),
    /*#__PURE__*/ _createElementVNode("i", {
        class: "fa fa-info-circle",
        title: "Exibiremos os links de suas Redes Sociais na sua campanha para aumentar o engajamento."
    })
], -1));
const _hoisted_7 = { class: "row" };
const _hoisted_8 = { class: "col-sm-12" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "" }, " Instragram ", -1));
const _hoisted_10 = { class: "input-group" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "input-group-addon" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fab fa-instagram" })
], -1));
const _hoisted_12 = { class: "col-sm-12" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "" }, " Facebook ", -1));
const _hoisted_14 = { class: "input-group" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "input-group-addon" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fab fa-facebook" })
], -1));
const _hoisted_16 = { class: "col-sm-12" };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "" }, " Youtube ", -1));
const _hoisted_18 = { class: "input-group" };
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "input-group-addon" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fab fa-youtube" })
], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_SummernoteEditor = _resolveComponent("SummernoteEditor");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_SummernoteEditor, {
                    modelValue: _ctx.campanha.descricao,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.campanha.descricao) = $event)),
                    config: _ctx.summernoteOptions
                }, null, 8, ["modelValue", "config"])
            ])
        ]),
        _createElementVNode("fieldset", null, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.campanha.rs_instagram_url) = $event)),
                            placeholder: "Ex: https://instagram.com/meu-canal"
                        }, null, 512), [
                            [_vModelText, _ctx.campanha.rs_instagram_url]
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.campanha.rs_facebook_url) = $event)),
                            placeholder: "Ex: https://facebook.com/meu-canal"
                        }, null, 512), [
                            [_vModelText, _ctx.campanha.rs_facebook_url]
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.campanha.rs_youtube_url) = $event)),
                            placeholder: "Ex: https://youtube.com/meu-canal"
                        }, null, 512), [
                            [_vModelText, _ctx.campanha.rs_youtube_url]
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
